import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
    persist(
        (set, get) => ({
            items: [],

            addToCart: (product) => {
                const items = get().items;
                const existingIndex = items.findIndex(item => item.id === product.id);

                if (existingIndex > -1) {
                    // Replace existing item (allows updating team size/price)
                    const newItems = [...items];
                    newItems[existingIndex] = product;
                    set({ items: newItems });
                    return false; // False indicates it was updated/already there, not newly added
                }

                set({ items: [...items, product] });
                return true;
            },

            removeFromCart: (productName) => {
                set({ items: get().items.filter(item => item.name !== productName) });
            },

            clearCart: () => {
                set({ items: [] });
            },

            getCartTotal: () => {
                return get().items.reduce((total, item) => {
                    return total + (item.amount || 0);
                }, 0);
            }
        }),
        {
            name: 'voe-cart-storage', // unique name
        }
    )
);

export default useCartStore;
